export const me = {
  pathname: '/me'
}
